import { HeaderText } from 'components/atoms/Texts/HeaderText';
import React, { ChangeEvent, useState } from 'react';
import useStyle from './formLogin.style';
import emojis from 'theme/emoji';
import { FeatureContainer } from 'components/molecules/Containers/FeatureContainer';
import { TextInput } from 'components/atoms/Inputs/TextInput';
import { LabelWithoutBG } from 'components/atoms/Label/Label.stories';
import { ButtonWithText } from 'components/atoms/Buttons/ButtonWithText';
import { IconButton } from 'components/atoms/Buttons/IconButton';
import goToPage from 'helpers/page/goToPage';
import { trackEvent } from 'services/matomo/trackEvent';

export interface FormLoginProps {
  mailValue: string;
  onChangeMailValue: (e: ChangeEvent<HTMLInputElement>) => void;
  passwordValue: string;
  onChangePasswordValue: (e: ChangeEvent<HTMLInputElement>) => void;
  onClickConnect: () => Promise<void>;
  helperTextMail?: string;
  helperTextPassword?: string;
  passwordLostLink?: string;
  isValid: boolean;
  loading: boolean;
}

export const FormLogin = ({
  mailValue = '',
  onChangeMailValue,
  passwordValue = '',
  onChangePasswordValue,
  onClickConnect,
  helperTextMail,
  helperTextPassword,
  passwordLostLink,
  isValid,
  loading
}) => {
  const classes = useStyle();
  const [passwordHide, setpasswordHide] = useState(true);

  return (
    <div className={classes.root}>
      <HeaderText color="white" text="Identifiez-vous" emoji={emojis['Key']} />
      <FeatureContainer>
        <div className={classes.zone}>
          <LabelWithoutBG text="Votre mail ou nom d'utilisateur" />
          <TextInput
            onChange={onChangeMailValue}
            value={mailValue}
            placeHolder="ex: VillePrenom22..."
          />
          {helperTextMail && <p className={classes.error}>{helperTextMail}</p>}
          <LabelWithoutBG text="Mot de passe" />
          <TextInput
            onChange={onChangePasswordValue}
            value={passwordValue}
            placeHolder="ex: Mdp1234$..."
            type={passwordHide ? 'password' : 'text'}
            iconButton={
              <IconButton
                variant="backless"
                onClick={() => setpasswordHide(!passwordHide)}
                icon={passwordHide ? 'EyeOff' : 'EyeOn'}
                size="small"
              />
            }
          />
          {helperTextPassword && (
            <p className={classes.error}>{helperTextPassword}</p>
          )}
        </div>
        <div className={classes.buttons}>
          <ButtonWithText
            content="Se connecter"
            onClick={onClickConnect}
            disabled={!isValid}
            loading={loading}
          />
          <ButtonWithText
            content="Mot de passe oublié"
            onClick={() => {
              trackEvent('Login', 'Clicked', 'Mot de passe oublié');
              goToPage(passwordLostLink);
            }}
            variant="text"
            icon="Interogation"
            iconColor=""
          />
        </div>
      </FeatureContainer>
    </div>
  );
};
